import React from "react";
import { UploadImg } from "../Components";

export const Photo = () => {
  return <UploadImg />;
};
